import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import logo from '../../../public/logo-hori-white.png';
import { useRouter } from 'next/router';
import { Popup } from '../Shared';
import {
  EmailIconPrimary,
  PhoneIconPrimary,
  ZaloIconPrimary,
} from '@/assets/icons';
import { AnimatePresence, motion } from 'framer-motion';

export const NavLink = [
  { name: 'Trang chủ', href: '/' },
  { name: 'Sản phẩm', href: '/products' },
  // { name: 'Dự án', href: '/projects' },
  { name: 'Về chúng tôi', href: '/about' },
  { name: 'Liên hệ', href: '/contact' },
];

const Header = () => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [isSidebar, setIsSidebar] = useState(false);
  const togglePopup = () => setIsOpen(!isOpen);
  const [isScrolled, setIsScrolled] = useState(false);
  const prevScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Không ẩn header khi đang ở top (scrollY < 50px)
      if (currentScrollY < 50) {
        setIsScrolled(false);
      } else {
        setIsScrolled(currentScrollY > prevScrollY.current);
      }
      prevScrollY.current = currentScrollY;
    };

    // Gọi một lần để khởi tạo state ban đầu
    handleScroll();

    window?.addEventListener('scroll', handleScroll);

    return () => {
      window?.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
      <div
        className={`sticky top-0 z-50 w-full shadow-md duration-500 bg-primary text-white ${
          isScrolled
            ? '-translate-y-[56px] lg:-translate-y-[80px]'
            : 'translate-y-0'
        } `}
      >
        <div className="flex w-full container py-3 items-center justify-between">
          <Link
            href={'/'}
            className="relative h-10 md:h-14 w-[60px] md:w-[90px]"
          >
            <Image
              alt="Logo Trường Thọ Food - Công ty trứng gà uy tín"
              src={logo}
              fill
              style={{ objectFit: 'contain' }}
            />
          </Link>
          <div className="md:flex gap-8 items-center hidden">
            {NavLink.map((item, index) => (
              <Link
                href={item.href}
                key={index}
                className={`${
                  router.asPath === item?.href
                    ? 'text-white after:border-b-2 after:border-white'
                    : 'text-white/80'
                } hover:text-white hover:after:border-b-2 hover:after:border-white text-[18px] after:absolute after:w-full after:h-full after:inset-0 relative uppercase font-medium`}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={togglePopup}
              className="uppercase h-fit whitespace-nowrap duration-300 w-fit text-[18px] pt-2 pb-1 px-4 font-medium rounded-full border border-white bg-white text-primary"
            >
              Nhận báo giá
            </button>
          </div>
          <button
            aria-label="menu"
            className={`relative z-40 flex w-fit min-w-[100px] justify-end md:hidden`}
            onClick={() => setIsSidebar(!isSidebar)}
          >
            <div className="flex flex-col gap-2">
              <div
                className={`h-[2px] w-8 rounded-full bg-white duration-500 ${
                  isSidebar && 'translate-y-3 rotate-45'
                }`}
              />
              <div
                className={`h-[2px] w-8 rounded-full bg-white duration-500 ${
                  isSidebar && 'opacity-0'
                }`}
              />
              <div
                className={`h-[2px] w-8 rounded-full bg-white duration-500 ${
                  isSidebar && '-translate-y-2 -rotate-45'
                }`}
              />
            </div>
          </button>
        </div>
      </div>{' '}
      <Popup isOpen={isOpen} onClose={togglePopup}>
        <div className="flex flex-col gap-4 pt-4">
          <div className="flex w-full items-center flex-col">
            <p className="text-[28px] font-bold text-primary">
              NHẬN BÁO GIÁ NGAY!
            </p>
            <p className="text-[18px] font-medium text-gray-500 ">
              Liên hệ với chúng tôi ngay để nhận được giá tốt nhất!
            </p>
          </div>
          <div className="flex w-full gap-4">
            <div className="w-full border-2 border-gray-200 rounded-2xl overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.462263816798!2d106.75067327532068!3d10.928411556371374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3174d9ba0594d31d%3A0x8f4d20a6a75ce6be!2zNzUgVsWpbmcgVGhp4buHbiwgVMOibiDEkMO0bmcgSGnhu4dwLCBExKkgQW4sIELDrG5oIETGsMahbmcsIFZpZXRuYW0!5e0!3m2!1sen!2s!4v1766288828363!5m2!1sen!2s"
                className="w-[450px] h-full"
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="flex flex-col gap-3">
              <div className="w-[450px] flex items-center justify-between border-2 border-gray-200 p-5 rounded-2xl hover:shadow-md hover:bg-gray-200 duration-300">
                <div className="flex flex-col gap-2">
                  <EmailIconPrimary />
                  <p className="font-medium text-[18px]">Email</p>
                  <p className="underline">truongthofood68@gmail.com</p>
                </div>
                <a
                  href="mailto:truongthofood68@gmail.com"
                  className="bg-primary h-fit whitespace-nowrap text-white duration-300 w-fit text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-primary hover:bg-white relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-primary inline-block text-center"
                >
                  Gửi Email
                </a>
              </div>
              <div className="w-[450px] flex items-center justify-between border-2 border-gray-200 p-5 rounded-2xl hover:shadow-md hover:bg-gray-200 duration-300">
                <div className="flex flex-col gap-2">
                  <PhoneIconPrimary />
                  <p className="font-medium text-[18px]">Hotline</p>
                  <p className="underline">083 419 4986</p>
                </div>
                <a
                  href="tel:0834194986"
                  className="bg-primary h-fit whitespace-nowrap text-white duration-300 w-fit text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-primary hover:bg-white relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-primary inline-block text-center"
                >
                  Gọi ngay
                </a>
              </div>
              <div className="w-[450px] flex items-center justify-between border-2 border-gray-200 p-5 rounded-2xl hover:shadow-md hover:bg-gray-200 duration-300">
                <div className="flex flex-col gap-2">
                  <ZaloIconPrimary />
                  <p className="font-medium text-[18px]">Zalo</p>
                  <p className="underline">083 419 4986</p>
                </div>
                <a
                  href="https://zalo.me/0834194986"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-primary h-fit whitespace-nowrap text-white duration-300 w-fit text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-primary hover:bg-white relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-primary inline-block text-center"
                >
                  Kết nối
                </a>
              </div>
            </div>
          </div>
        </div>
      </Popup>
      <AnimatePresence>
        {isSidebar && (
          <motion.div
            initial={{ right: '-100%' }}
            animate={{ right: '0%' }}
            exit={{ right: '-100%' }}
            transition={{ duration: 0.3 }}
            className={`fixed top-0 z-30 flex h-full w-full flex-col items-center justify-start gap-1 bg-primary px-3 pt-24`}
          >
            <div className="h-[1px] w-full bg-white/10" />
            {NavLink.map((item, index) => (
              <Link
                onClick={() => setIsSidebar(false)}
                href={item.href}
                key={index}
                className={`${
                  router.asPath === item?.href
                    ? 'text-white after:border-b-2 after:border-white'
                    : 'text-white/80'
                } hover:text-white hover:after:border-b-2 hover:after:border-white text-[18px] after:absolute after:w-full after:h-full after:inset-0 relative uppercase font-medium`}
              >
                {item.name}
              </Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
